import React from "react";
import styles from "../statics/styles/file-upload-viewer-scss.js";
const DocIcon = (props) => /* @__PURE__ */ React.createElement("svg", { xmlns: "http://www.w3.org/2000/svg", width: "40", height: "42", viewBox: "0 0 40 42", ...props }, /* @__PURE__ */ React.createElement("g", { fill: "none", fillRule: "evenodd" }, /* @__PURE__ */ React.createElement("g", { className: styles.file_upload_icon_frame, strokeLinejoin: "bevel" }, /* @__PURE__ */ React.createElement("path", { fill: "currentColor", d: "M35.5 41.5h-32V.5h19.45L35.5 13.31z" }), /* @__PURE__ */ React.createElement("path", { d: "m22.59 13.36 12.91-.05-.64-.63L23.59 1.14 22.95.5z" })), /* @__PURE__ */ React.createElement(
  "path",
  {
    className: styles.file_upload_icon_background,
    d: "m15.1 19.6 1.5 6.2.3 1.8.3-1.7 1.3-6.3h2.4l1.3 6.2.3 1.8.4-1.7 1.4-6.3h2.4l-3.1 10.9h-2.2L20 24.1l-.3-2.1-.4 2.1-1.4 6.4h-2.1l-3.1-10.9z"
  }
)));
export {
  DocIcon
};
//# sourceMappingURL=doc-icon.js.map
